import { useTranslation } from 'react-i18next';

import { Field, Radio } from '~/components/Form';

import type { VatRegulationToggleProps as Props, VatRegulationType } from './types';

import { optionsStyle } from './VatRegulationToggle.css';

export const VatRegulationToggle = ({ error, onChange, value }: Props) => {
  const { t } = useTranslation(['settings']);

  return (
    <Field.Root invalid={!!error}>
      <Radio.Group<VatRegulationType | null> onValueChange={(value) => onChange(value)} value={value}>
        <div className={optionsStyle}>
          {(['vatNormal', 'vatExempt'] satisfies VatRegulationType[]).map((type) => (
            <Radio.Root key={type} value={type}>
              <Radio.Label>{t(`settings:profile.vatRegulation.toggle.${type}`)}</Radio.Label>

              <Radio.Description>{t(`settings:profile.vatRegulation.toggleDescription.${type}`)}</Radio.Description>
            </Radio.Root>
          ))}
        </div>
      </Radio.Group>

      <Field.Error match={!!error}>{error}</Field.Error>
    </Field.Root>
  );
};
